import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../message";
import EventBus from "../../../utils/EventBus";
import ShowcaseAPI from "../../../Api/showcaseapi";



export const fetchTemplates = createAsyncThunk("template/fetchTemplates", async (params, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.getTemplates(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const fetchTemplatesById = createAsyncThunk("template/fetchTemplatesById", async (params, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.getTemplateById(params);
        console.log("res",response.data)
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const addTemplate = createAsyncThunk("template/addTemplate", async (formData, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.addTemplate(formData);
        const message=(response.message)
        
            thunkAPI.dispatch(setMessage(message))
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const updateTemplate = createAsyncThunk("template/updateTemplate", async ({ id, formData }, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.updateTemplate(id, formData);
        const message=(response.message)
        
        thunkAPI.dispatch(setMessage(message))
        return response;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const deleteTemplate = createAsyncThunk("template/deleteTemplate", async (id, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.deleteTemplate(id);
        return id;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

const templateSlice = createSlice({
    name: "template",
    initialState: {
        templates: [],
        selectedTemplate: null, 
        error: null,
        totalCount: 0
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTemplates.fulfilled, (state, action) => {
                state.templates = action.payload.data;
                state.totalCount = action.payload.totalCount;
            })
            .addCase(addTemplate.fulfilled, (state, action) => {
                state.templates.push(action.payload);
            })

            .addCase(fetchTemplatesById.fulfilled, (state, action) => {
                state.selectedTemplate = action.payload;
                console.log("ac",action.payload)
            })
            .addCase(fetchTemplatesById.rejected, (state, action) => {
                state.error = action.payload;
            })

            .addCase(updateTemplate.fulfilled, (state, action) => {
                console.log("res",action.payload.data)
                const {
                    arg: { id },
                  } = action.meta;
                  if(id){
                state.templates = state.templates.map((template) =>
                    template.id === id ? action.payload.data : template
                );

            }
            })          
            
            .addCase(deleteTemplate.fulfilled, (state, action) => {
                state.templates = state.templates.filter((template) => template.id !== action.payload);
            })
            .addCase(fetchTemplates.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(addTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteTemplate.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

const { reducer } = templateSlice;
export default reducer;
